// layouts/Main.js
import React from "react";
import { useAuth } from "../hooks/useAuth";
import Header from "./Header";
import Sidebar from "../layouts/Sidebar";
import { Spinner } from "react-bootstrap";
import { Outlet, useLocation } from "react-router-dom";

export default function Main() {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  // Liste des routes qui ne doivent PAS avoir le layout Main
  const excludedRoutes = [
    '/apps/validationOTP',
    '/pages/signin2',
    '/pages/signup2'
  ];

  // Vérifier si la route actuelle est exclue
  const isExcludedRoute = excludedRoutes.some(route => 
    location.pathname.includes(route)
  );

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
        <span className="ms-2">Chargement de l'application...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null; // Le ProtectedRoute gère la redirection
  }

  // Si c'est une route exclue, ne pas afficher le layout Main
  if (isExcludedRoute) {
    return <Outlet />;
  }

  return (
    <div className="main-wrapper">
      <Header user={user} />
      <Sidebar user={user} />
      <Outlet />
      {/* Le reste de votre layout Main */}
    </div>
  );
}